import { useState } from 'react';

const FAQS = [
  {
    q: 'What are the best cabins in Highlands NC?',
    a: 'Highlands offers a range of cabins, including luxury and pet-friendly options located near waterfalls, hiking trails, and downtown. Glen Falls Luxury Cabin is one of the most highly rated, consistently recognized as a Guest Favorite on Airbnb.',
  },
  {
    q: 'Are there cabins near waterfalls in Highlands NC?',
    a: 'Yes, many cabins in Highlands, North Carolina are located near popular waterfalls such as Glen Falls and Dry Falls. These properties are especially popular with visitors who want easy access to the area\'s natural attractions.',
  },
  {
    q: 'Is Highlands NC a good place to stay?',
    a: 'Highlands is known for its mountain scenery, outdoor activities, and peaceful atmosphere, making it a popular destination for cabin stays. At 4,118 feet elevation, it offers cool summers and dramatic fall foliage that draw visitors throughout the year.',
  },
];

export default function HomeFAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="bg-[#FAFAF8] py-20 px-6 lg:px-14">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-4">/ Quick Answers</p>
          <h2 className="font-cormorant text-4xl md:text-5xl text-[#1A1A18] font-light">
            Frequently Asked<br /><em className="italic">Questions</em>
          </h2>
        </div>

        <div className="divide-y divide-[#EDE8E0]">
          {FAQS.map((faq, idx) => (
            <div key={idx} className="py-6">
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-start justify-between gap-6 text-left cursor-pointer group"
                aria-expanded={openIdx === idx}
              >
                <h3 className="font-jost text-base font-medium text-[#1A1A18] group-hover:text-[#2D4A3E] transition-colors leading-snug">
                  {faq.q}
                </h3>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className={`${openIdx === idx ? 'ri-subtract-line' : 'ri-add-line'} text-[#2D4A3E] text-lg transition-transform`} />
                </div>
              </button>
              {openIdx === idx && (
                <p className="mt-4 text-[#5C5850] font-jost text-sm leading-relaxed pr-10">
                  {faq.a}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: FAQS.map((faq) => ({
              '@type': 'Question',
              name: faq.q,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.a,
              },
            })),
          }),
        }}
      />
    </section>
  );
}
